import {formatDateToEsWithReducerDays} from '@/utils/utils';
import {ButtonCancel, Loader, Nav, SaveButton} from '@components/faqs/StyledFAQ';
import {RootState} from '@config/store';
import {Box, Modal, Typography} from '@mui/material';
import {styled, useTheme} from '@mui/material/styles';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

export const StyledModal = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 85vw;
    border-radius: 10px;
    padding-left: 60px;
    padding-right: 60px;
`;

interface IConfirmPOModal {
    isModalOpen: boolean;
    closeModal: any;
    deliveryDate: Date;
    updatedOrderFn: () => void;
}

const ConfirmPOModal = (props: IConfirmPOModal) => {
    const theme = useTheme();
    const {isModalOpen, closeModal, deliveryDate, updatedOrderFn} = props;
    const loading = useSelector((state: RootState) => state.purchaceOrderReducers.loading);
    const error = useSelector((state: RootState) => state.purchaceOrderReducers.error);
    const purchaseOrderUpdate = useSelector(
        (state: RootState) => state.purchaceOrderReducers.purchaseOrderUpdate
    );
    const [isConfirm, setIsConfirm] = useState(false);

    useEffect(() => {
        if (purchaseOrderUpdate && !loading && !error) {
            setIsConfirm(true);
        }
    }, [purchaseOrderUpdate]);

    return (
        <StyledModal open={isModalOpen} onClose={closeModal}>
            <Box
                sx={{
                    background: '#FFF',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '10px',
                }}
            >
                <Nav>
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontFamily: theme.typography.fontFamily,
                            fontWeight: 700,
                            color: 'white',
                            marginLeft: '10px',
                        }}
                    >
                        Aceptar orden Total
                    </Typography>
                </Nav>
                {isConfirm ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '20px 100px',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '18px',
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: 700,
                                color: 'black',
                                margin: '20px 0px 20px 0',
                            }}
                        >
                            Confirmación de entrega total
                        </Typography>
                        <svg
                            width="70"
                            height="69"
                            viewBox="0 0 70 69"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M32.8338 66.0172C15.2741 64.8272 1.88067 49.4865 3.0707 31.9268C4.26072 14.367 19.6014 0.973656 37.1611 2.16368C54.7209 3.3537 68.1143 18.6944 66.9242 36.2541C65.7342 53.8138 50.3935 67.2072 32.8338 66.0172ZM36.8005 7.48481C22.1674 6.49312 9.38351 17.6543 8.39182 32.2874C7.40014 46.9205 18.5613 59.7044 33.1944 60.6961C47.8275 61.6878 60.6114 50.5266 61.6031 35.8935C62.5948 21.2604 51.4336 8.47649 36.8005 7.48481ZM33.9561 45.5128C33.654 46.0269 33.3699 46.275 33.0858 46.523C32.2516 47.001 31.9855 46.983 31.4534 46.9469C30.3892 46.8748 29.8931 46.3066 29.1671 45.1883L22.2224 37.2339C21.4963 36.1155 21.5865 34.7853 22.7228 33.7931C23.5751 33.0491 25.1714 33.1573 25.9155 34.0095L31.3721 40.2594L44.769 20.0524C45.1252 18.7401 46.7396 18.5822 48.0338 19.2045C49.31 20.0928 49.4679 21.7072 48.8456 23.0014L33.9561 45.5128Z"
                                fill="#4BBC68"
                            />
                        </svg>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: 500,
                                color: 'black',
                                marginLeft: '10px',
                                marginTop: '20px',
                            }}
                        >
                            La orden de compra ha sido confirmada para entrega el{' '}
                            {formatDateToEsWithReducerDays(deliveryDate)}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: 500,
                                color: 'black',
                                marginLeft: '10px',
                            }}
                        >
                            Estaremos enviando un recordatorio 3 días antes de la fecha promesa de
                            entrega.
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '50px',
                                alignItems: 'center',
                                marginTop: '40px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '10px',
                                    alignItems: 'center',
                                }}
                            >
                                <svg
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_2834_31745)">
                                        <path
                                            d="M24.6386 18.909C24.4998 17.4639 23.2098 16.329 21.7075 16.329C21.5278 16.329 21.3849 16.1861 21.3849 16.0065V11.1976C21.3849 7.6256 19.0989 4.51086 15.9514 3.34742C15.9882 3.16369 16.0086 2.97595 16.0086 2.78813C16.0086 1.2492 14.7595 0 13.2204 0C11.6814 0 10.4322 1.2492 10.4322 2.7882C10.4322 2.97192 10.4526 3.15558 10.4853 3.33113C9.40352 3.71487 8.40335 4.32311 7.55017 5.14773C5.94177 6.699 5.05593 8.78502 5.05593 11.0221V16.0066C5.05593 16.1821 4.91304 16.3291 4.73341 16.3291C3.22706 16.3291 1.94112 17.464 1.80232 18.9091C1.72474 19.7133 1.99014 20.5134 2.53306 21.1094C3.0719 21.7014 3.84348 22.0443 4.64765 22.0443H9.57088C9.77499 23.8772 11.3344 25.3101 13.2204 25.3101C15.1064 25.3101 16.6659 23.8772 16.87 22.0443H21.7932C22.5975 22.0443 23.369 21.7014 23.9078 21.1094C24.4467 20.5133 24.7161 19.7132 24.6386 18.909ZM13.2204 1.63287C13.8572 1.63287 14.3757 2.15133 14.3757 2.78813C14.3757 2.84117 14.3675 2.89018 14.3593 2.94322C14.0817 2.90239 13.8 2.87382 13.5184 2.86564C13.0326 2.84928 12.5549 2.882 12.0814 2.94731C12.0732 2.89427 12.065 2.84526 12.065 2.79222C12.0652 2.15133 12.5836 1.63287 13.2204 1.63287ZM13.2204 23.6771C12.2366 23.6771 11.412 22.9749 11.2201 22.0442H15.2207C15.0289 22.975 14.2043 23.6771 13.2204 23.6771ZM22.6995 20.0112C22.4627 20.2684 22.1443 20.4113 21.7932 20.4113H4.64772C4.29663 20.4113 3.97826 20.2684 3.74143 20.0112C3.50466 19.7541 3.39443 19.4152 3.43117 19.0642C3.4883 18.4478 4.06395 17.962 4.7375 17.962C5.81524 17.962 6.6929 17.0843 6.6929 16.0066V11.0221C6.6929 9.23407 7.40319 7.56445 8.68913 6.32343C9.91379 5.13552 11.5141 4.49047 13.2204 4.49047C13.3021 4.49047 13.3796 4.49047 13.4613 4.49456C16.9271 4.617 19.7521 7.62567 19.7521 11.1976V16.0066C19.7521 17.0843 20.6297 17.962 21.7075 17.962C22.381 17.962 22.9567 18.4478 23.0138 19.0642C23.0465 19.4152 22.9362 19.75 22.6995 20.0112Z"
                                            fill="#00ACFF"
                                        />
                                        <path
                                            d="M2.64786 9.79718C3.02343 9.79718 3.36225 9.53594 3.44392 9.15629C3.83987 7.36416 4.73388 5.73129 6.04021 4.43314C6.35864 4.11471 6.35864 3.59626 6.04021 3.27789C5.72178 2.95945 5.20332 2.95945 4.88495 3.27789C3.35822 4.79637 2.30905 6.711 1.84779 8.80922C1.74983 9.2501 2.02742 9.68688 2.4683 9.78082C2.53361 9.79309 2.59074 9.79718 2.64786 9.79718Z"
                                            fill="#00ACFF"
                                        />
                                        <path
                                            d="M23.7915 9.79743C23.8486 9.79743 23.9099 9.78925 23.967 9.77705C24.4079 9.67909 24.6855 9.24633 24.5875 8.80545C24.1262 6.70716 23.0771 4.79669 21.5503 3.27398C21.2319 2.95555 20.7134 2.95555 20.3951 3.27398C20.0767 3.59242 20.0766 4.11087 20.3951 4.42924C21.6973 5.72738 22.5954 7.36033 22.9913 9.15238C23.0771 9.53613 23.4159 9.79743 23.7915 9.79743Z"
                                            fill="#00ACFF"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2834_31745">
                                            <rect
                                                width="25.31"
                                                height="25.31"
                                                fill="white"
                                                transform="translate(0.5625)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontFamily: theme.typography.fontFamily,
                                        fontWeight: 500,
                                        color: 'black',
                                        marginLeft: '10px',
                                    }}
                                >
                                    {formatDateToEsWithReducerDays(deliveryDate, 3)}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '10px',
                                    alignItems: 'center',
                                }}
                            >
                                <svg
                                    width="29"
                                    height="19"
                                    viewBox="0 0 29 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M26.7552 8.28027L26.0151 5.32027C26.2175 5.27729 26.3693 5.0978 26.3693 4.88275V4.4055C26.3693 3.36929 25.5262 2.5263 24.4901 2.5263H21.1195V1.54189C21.1195 1.03198 20.7047 0.617188 20.1948 0.617188H3.01339C2.50349 0.617188 2.08869 1.03198 2.08869 1.54189V9.65532C2.08869 9.9024 2.289 10.1028 2.53614 10.1028C2.78322 10.1028 2.98358 9.90245 2.98358 9.65532V1.54189C2.98358 1.52542 2.99692 1.51208 3.01339 1.51208H20.1947C20.2112 1.51208 20.2245 1.52542 20.2245 1.54189V9.65543C20.2245 9.90251 20.4248 10.1029 20.6719 10.1029C20.919 10.1029 21.1194 9.90257 21.1194 9.65543V9.14821H26.3975C26.398 9.14821 26.3983 9.14832 26.3987 9.14832C26.3991 9.14832 26.3995 9.14826 26.3999 9.14826C27.0494 9.14871 27.6009 9.575 27.7903 10.1624H26.399C26.1519 10.1624 25.9516 10.3627 25.9516 10.6099V11.5644C25.9516 12.3374 26.5805 12.9663 27.3535 12.9663H27.8606V14.935H26.6907C26.3064 13.8253 25.2515 13.0259 24.0127 13.0259C22.774 13.0259 21.719 13.8253 21.3347 14.935H21.1193V11.5643C21.1193 11.3172 20.919 11.1169 20.6718 11.1169C20.4248 11.1169 20.2244 11.3172 20.2244 11.5643V14.9349H10.9412C10.5569 13.8252 9.50201 13.0258 8.26326 13.0258C7.02451 13.0258 5.96954 13.8252 5.58527 14.9349H3.01339C2.99692 14.9349 2.98358 14.9215 2.98358 14.9051V13.9207H4.92245C5.16953 13.9207 5.3699 13.7204 5.3699 13.4733C5.3699 13.2261 5.16958 13.0258 4.92245 13.0258H0.627135C0.380054 13.0258 0.179688 13.2261 0.179688 13.4733C0.179688 13.7204 0.379998 13.9207 0.627135 13.9207H2.08875V14.9051C2.08875 15.415 2.50354 15.8298 3.01344 15.8298H5.43034C5.43023 15.8397 5.42956 15.8496 5.42956 15.8596C5.42956 17.4221 6.7008 18.6933 8.26326 18.6933C9.82572 18.6933 11.097 17.4221 11.097 15.8596C11.097 15.8495 11.0963 15.8397 11.0962 15.8298H21.1798C21.1797 15.8397 21.179 15.8496 21.179 15.8596C21.179 17.4221 22.4502 18.6933 24.0127 18.6933C25.5752 18.6933 26.8464 17.4221 26.8464 15.8596C26.8464 15.8495 26.8457 15.8397 26.8456 15.8298H28.3081C28.5552 15.8298 28.7555 15.6295 28.7555 15.3823V10.6098C28.7556 9.43145 27.8862 8.45245 26.7552 8.28027ZM21.1195 3.42114H24.4901C25.0328 3.42114 25.4744 3.86273 25.4744 4.4055V4.43531H21.1195V3.42114ZM21.1195 8.25337V5.33014H25.0952L25.826 8.25337H21.1195ZM8.26326 17.7985C7.19418 17.7985 6.3244 16.9288 6.3244 15.8597C6.3244 14.7906 7.19418 13.9208 8.26326 13.9208C9.33234 13.9208 10.2021 14.7906 10.2021 15.8597C10.2021 16.9288 9.33234 17.7985 8.26326 17.7985ZM24.0128 17.7985C22.9437 17.7985 22.074 16.9288 22.074 15.8597C22.074 14.7906 22.9437 13.9208 24.0128 13.9208C25.0819 13.9208 25.9517 14.7906 25.9517 15.8597C25.9517 16.9288 25.0819 17.7985 24.0128 17.7985ZM27.8607 12.0714H27.3536C27.074 12.0714 26.8465 11.8439 26.8465 11.5643V11.0572H27.8607V12.0714H27.8607Z"
                                        fill="#00ACFF"
                                    />
                                    <path
                                        d="M8.26064 14.9355C7.75073 14.9355 7.33594 15.3503 7.33594 15.8602C7.33594 16.3701 7.75073 16.7849 8.26064 16.7849C8.77054 16.7849 9.18533 16.3701 9.18533 15.8602C9.18533 15.3503 8.77054 14.9355 8.26064 14.9355Z"
                                        fill="#00ACFF"
                                    />
                                    <path
                                        d="M24.0106 14.9355C23.5007 14.9355 23.0859 15.3503 23.0859 15.8602C23.0859 16.3701 23.5007 16.7849 24.0106 16.7849C24.5205 16.7849 24.9353 16.3701 24.9353 15.8602C24.9353 15.3503 24.5205 14.9355 24.0106 14.9355Z"
                                        fill="#00ACFF"
                                    />
                                    <path
                                        d="M18.7619 13.0264H12.0803C11.8332 13.0264 11.6328 13.2267 11.6328 13.4738C11.6328 13.721 11.8331 13.9213 12.0803 13.9213H18.7619C19.009 13.9213 19.2093 13.721 19.2093 13.4738C19.2093 13.2267 19.009 13.0264 18.7619 13.0264Z"
                                        fill="#00ACFF"
                                    />
                                    <path
                                        d="M7.30738 11.1172H1.58026C1.33318 11.1172 1.13281 11.3175 1.13281 11.5646C1.13281 11.8118 1.33312 12.0121 1.58026 12.0121H7.30738C7.55446 12.0121 7.75483 11.8118 7.75483 11.5646C7.75483 11.3175 7.55446 11.1172 7.30738 11.1172Z"
                                        fill="#00ACFF"
                                    />
                                    <path
                                        d="M15.7423 5.04312C15.5676 4.86843 15.2843 4.86843 15.1096 5.04318L11.1306 9.02209L9.06068 6.95218C8.88593 6.77743 8.60263 6.77743 8.42794 6.95218C8.25319 7.12693 8.25319 7.41018 8.42794 7.58492L10.8142 9.97123C10.9016 10.0586 11.0161 10.1023 11.1306 10.1023C11.2451 10.1023 11.3596 10.0586 11.4469 9.97123L15.7422 5.67592C15.917 5.50112 15.917 5.21787 15.7423 5.04312Z"
                                        fill="#00ACFF"
                                    />
                                </svg>

                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontFamily: theme.typography.fontFamily,
                                        fontWeight: 500,
                                        color: 'black',
                                        marginLeft: '10px',
                                    }}
                                >
                                    {formatDateToEsWithReducerDays(deliveryDate)}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            alignItems: 'center',
                            padding: '20px 140px',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '18px',
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: 700,
                                color: 'black',
                                marginLeft: '10px',
                            }}
                        >
                            Confirmación de entrega TOTAL
                        </Typography>
                        <svg
                            width="102"
                            height="102"
                            viewBox="0 0 102 102"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M51 97.2188C56.2812 97.2188 60.5625 92.9375 60.5625 87.6562C60.5625 82.375 56.2812 78.0938 51 78.0938C45.7188 78.0938 41.4375 82.375 41.4375 87.6562C41.4375 92.9375 45.7188 97.2188 51 97.2188Z"
                                fill="#F9C33D"
                            />
                            <path
                                d="M54.1875 96.661C53.1661 97.0329 52.087 97.2217 51 97.2188C48.4639 97.2188 46.0316 96.2113 44.2383 94.418C42.445 92.6247 41.4375 90.1924 41.4375 87.6563C41.4375 85.1202 42.445 82.6879 44.2383 80.8946C46.0316 79.1013 48.4639 78.0938 51 78.0938C52.087 78.0909 53.1661 78.2797 54.1875 78.6516C52.3306 79.3152 50.7243 80.5367 49.5886 82.1487C48.4528 83.7607 47.8432 85.6844 47.8432 87.6563C47.8432 89.6282 48.4528 91.5519 49.5886 93.1639C50.7243 94.7759 52.3306 95.9973 54.1875 96.661Z"
                                fill="#F7A83E"
                            />
                            <path
                                d="M51 17.5312C54.5208 17.5312 57.375 14.6771 57.375 11.1562C57.375 7.63543 54.5208 4.78125 51 4.78125C47.4792 4.78125 44.625 7.63543 44.625 11.1562C44.625 14.6771 47.4792 17.5312 51 17.5312Z"
                                fill="#F9C33D"
                            />
                            <path
                                d="M57.3754 11.9209C57.2339 12.9974 56.8199 14.02 56.1725 14.8916C55.5251 15.7633 54.6657 16.4551 53.676 16.9016C52.6863 17.348 51.5989 17.5343 50.517 17.4427C49.4351 17.3512 48.3945 16.9848 47.4939 16.3783C46.5932 15.7718 45.8625 14.9454 45.3708 13.9773C44.8791 13.0092 44.6428 11.9316 44.6844 10.8466C44.7259 9.76163 45.0438 8.70523 45.6081 7.77758C46.1723 6.84992 46.9642 6.08175 47.9085 5.5459C47.8579 5.81967 47.826 6.09656 47.8129 6.37465C47.8084 7.49584 48.0997 8.59838 48.6574 9.57104C49.2151 10.5437 50.0195 11.3521 50.9894 11.9146C51.9592 12.4771 53.0603 12.7739 54.1815 12.775C55.3027 12.7761 56.4044 12.4815 57.3754 11.9209Z"
                                fill="#F7A83E"
                            />
                            <path
                                d="M23.9062 65.3431V38.9347C23.9062 23.9057 35.8275 11.2353 50.8566 11.1557C54.4266 11.1368 57.9652 11.8236 61.2689 13.1767C64.5727 14.5299 67.5764 16.5226 70.1075 19.0403C72.6386 21.5581 74.6472 24.5513 76.0177 27.8478C77.3883 31.1444 78.0938 34.6793 78.0938 38.2494V65.3431C78.0938 67.8793 79.1012 70.3115 80.8945 72.1049C82.6879 73.8982 85.1201 74.9056 87.6562 74.9056H90.8438C92.5345 74.9056 94.156 75.5773 95.3516 76.7728C96.5471 77.9684 97.2188 79.5899 97.2188 81.2806C97.2188 82.9714 96.5471 84.5929 95.3516 85.7885C94.156 86.984 92.5345 87.6556 90.8438 87.6556H11.1562C9.46549 87.6556 7.84399 86.984 6.64844 85.7885C5.4529 84.5929 4.78125 82.9714 4.78125 81.2806C4.78125 79.5899 5.4529 77.9684 6.64844 76.7728C7.84399 75.5773 9.46549 74.9056 11.1562 74.9056H14.3438C16.8799 74.9056 19.3121 73.8982 21.1055 72.1049C22.8988 70.3115 23.9062 67.8793 23.9062 65.3431Z"
                                fill="#F9C33D"
                            />
                            <path
                                d="M74.9062 49.4062C87.2291 49.4062 97.2188 39.4166 97.2188 27.0938C97.2188 14.7709 87.2291 4.78125 74.9062 4.78125C62.5834 4.78125 52.5938 14.7709 52.5938 27.0938C52.5938 39.4166 62.5834 49.4062 74.9062 49.4062Z"
                                fill="#F7616C"
                            />
                            <path
                                d="M92.8824 40.29C90.9843 42.894 88.5447 45.056 85.7313 46.6273C82.918 48.1986 79.7976 49.1418 76.585 49.3922C73.3723 49.6425 70.1435 49.194 67.1207 48.0775C64.0979 46.961 61.3528 45.203 59.0742 42.9244C56.7957 40.6458 55.0377 37.9007 53.9212 34.8779C52.8047 31.8551 52.3562 28.6263 52.6065 25.4137C52.8568 22.201 53.8001 19.0807 55.3714 16.2673C56.9426 13.454 59.1046 11.0143 61.7087 9.11621C58.5758 13.4142 57.0813 18.69 57.4945 23.9925C57.9077 29.295 60.2014 34.2756 63.9623 38.0364C67.7231 41.7972 72.7036 44.091 78.0062 44.5042C83.3087 44.9173 88.5844 43.4228 92.8824 40.29Z"
                                fill="#EA3D53"
                            />
                            <path
                                d="M78.0938 14.3438C78.0938 12.5833 76.6667 11.1562 74.9062 11.1562C73.1458 11.1562 71.7188 12.5833 71.7188 14.3438V27.0938C71.7188 28.8542 73.1458 30.2812 74.9062 30.2812C76.6667 30.2812 78.0938 28.8542 78.0938 27.0938V14.3438Z"
                                fill="white"
                            />
                            <path
                                d="M74.9062 43.0312C76.6667 43.0312 78.0938 41.6042 78.0938 39.8438C78.0938 38.0833 76.6667 36.6562 74.9062 36.6562C73.1458 36.6562 71.7188 38.0833 71.7188 39.8438C71.7188 41.6042 73.1458 43.0312 74.9062 43.0312Z"
                                fill="white"
                            />
                            <path
                                d="M97.0116 82.8744C96.7419 83.9682 96.1927 84.9732 95.4178 85.7909C94.8178 86.3904 94.1041 86.8641 93.3187 87.1843C92.5333 87.5045 91.6919 87.6647 90.8438 87.6556H11.1562C9.46549 87.6556 7.84399 86.984 6.64844 85.7884C5.4529 84.5929 4.78125 82.9714 4.78125 81.2806C4.78125 79.5899 5.4529 77.9684 6.64844 76.7728C7.84399 75.5773 9.46549 74.9056 11.1562 74.9056H14.3438C16.8799 74.9056 19.3121 73.8981 21.1055 72.1048C22.8988 70.3115 23.9062 67.8793 23.9062 65.3431V38.9347C23.9062 23.9056 35.8275 11.2353 50.8566 11.1556C52.5621 11.1469 54.2646 11.3017 55.9406 11.6178C52.4254 14.2293 49.5709 17.628 47.6059 21.5415C45.6409 25.455 44.62 29.7743 44.625 34.1534V60.5619C44.625 63.098 43.6175 65.5303 41.8242 67.3236C40.0309 69.1169 37.5986 70.1244 35.0625 70.1244H31.875C30.1842 70.1244 28.5627 70.796 27.3672 71.9916C26.1717 73.1871 25.5 74.8086 25.5 76.4994C25.5 78.1901 26.1717 79.8116 27.3672 81.0072C28.5627 82.2027 30.1842 82.8744 31.875 82.8744H97.0116Z"
                                fill="#F7A83E"
                            />
                        </svg>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: 500,
                                color: 'black',
                                marginLeft: '10px',
                            }}
                        >
                            Estas a punto de confirmar una <b>ENTREGA TOTAL</b>
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: 500,
                                color: 'black',
                                marginLeft: '10px',
                            }}
                        >
                            ¿Estás seguro? Esta operación no se puede deshacer
                        </Typography>
                    </Box>
                )}
                <Box
                    sx={{
                        display: 'flex',
                        height: '56px',
                        alignItems: 'center',
                        margin: '20px',
                        justifyContent: 'flex-end',
                    }}
                >
                    <ButtonCancel onClick={closeModal}>CERRAR</ButtonCancel>
                    {!isConfirm && (
                        <SaveButton disabled={loading} onClick={updatedOrderFn}>
                            {loading ? <Loader size={24} color="info" /> : 'CONTINUAR'}
                        </SaveButton>
                    )}
                </Box>
            </Box>
        </StyledModal>
    );
};

export default ConfirmPOModal;
